module.exports = __webpack_public_path__ + "static/media/home_vaccine.f0ec9d92.png";